module.exports = __webpack_public_path__ + "static/img/background.17b14bc0.svg";